import { useLang } from '@/i18n';
import EfImg from 'elem/ui/ef-img';
import EfSpec from 'elem/ui/ef-spec';
import EfTitle from 'elem/ui/ef-title';
import { useRouter } from 'next/router';
import { FC } from 'react';
import css from './index.module.scss';

const TheComp: FC = () => {
    const { t } = useLang('dp3.landing.EU2');
    const { locale } = useRouter();

    return (
        <div
            id="dp3-teaser-EU2"
            className={`${css.thecomp} dp3-teaser-EU2 dp3-teaser-full GtmModuleData-section`}
            data-section-id={'dp3-EU2'}
            data-section-title={t('title')}
        >
            {locale !== 'ph' && <EfSpec className="spec-x" />}
            <EfTitle hasAnimation={false} className="big-title">
                {t('bigTitle')}
            </EfTitle>
            <EfSpec className="spec-x" />
            <EfTitle className="title" hasAnimation={false}>
                {t('title')}
            </EfTitle>
            <EfImg
                pc="https://websiteoss.ecoflow.com/upload/image/1725524254108/pc.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1725524254108/pc.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1725524254214/h5.jpg"
            />
        </div>
    );
};

export default TheComp;
